import React from "react";
import { useSelector } from "react-redux";
import CourseList from "../../components/academy/academy-courses/CourseList";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";

const AcademyCourses = () => {
  const userInfoData = useSelector(selectUser);

  console.log("User info data", userInfoData);

  if (!userInfoData) {
    return <div>Loading...</div>;
  }

  return (
    <HelmetWrapper title="WTF: Academy Courses">
      <CourseList userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default AcademyCourses;
